import script from "./LittleButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./LittleButton.vue?vue&type=script&setup=true&lang=ts"

import "./LittleButton.vue?vue&type=style&index=0&id=3a595c2f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a595c2f"]])

export default __exports__